<template>
  <div class="home">
      <Hooper ref="carousel" :vertical="true" :infiniteScroll="false" class="hooper" v-on:slide="slide">
          <Slide v-show="enableTutorial === true">
              <home-tutorial :key="card"></home-tutorial>
          </Slide>
          <Slide v-for="card in cards" :key="card">
              <card :card="card" :hide="false"></card>
          </Slide>
      </Hooper>
      <vue-swipe-component id="sheet" :card="cards[index]"></vue-swipe-component>
  </div>
</template>

<script>
// @ is an alias to /src
import HelloWorld from '@/components/HelloWorld.vue'
import VueSwing from 'vue-swing'
import BButton from "buefy/src/components/button/Button";
import Onboarding from "../components/onboarding";
import MakeOffer from "./MakeOffer";
import bus from '../bus';
import { Hooper, Slide } from 'hooper';
import 'hooper/dist/hooper.css';
import Card from "../components/card";
import VueSwipeComponent from "../components/vue-swipe-component";
import HomeTutorial from "../components/home-tutorial";

export default {
  name: 'home',
  components: {
      HomeTutorial,
      VueSwipeComponent,
      Card,
      MakeOffer,
      Onboarding,
      BButton,
      HelloWorld,
      VueSwing,
      Hooper,
      Slide
  },
  data() {
      return {
          cards: [],
          index: 0,
          showMakeOffer: false,
          enableTutorial: false
      }
  },
  methods: {
      slide(payload) {
          const vm = this;
          bus.$emit('pause');
          if(vm.index === 0 || (vm.index%7 === 0 && payload.currentSlide >= payload.slideFrom) || payload.currentSlide === 0) {
              vm.getRequest(8);
          }
          vm.index = payload.currentSlide - 1;
          if (vm.enableTutorial === true) {
              if (vm.index === 0) {
                  vm.enableTutorial = false;
                  localStorage.disableTutorial = true;
                  vm.index = payload.currentSlide;
              } else {
                  vm.index = payload.currentSlide - 1;
              }
          } else {
              vm.index = payload.currentSlide;
          }
      },
      getRequest(num) {
          const vm = this;
          vm.axios.get(vm.$host + "/match/random", {params: {num: parseInt(num)} })
              .then(function (res) {
                  var data = res.data;
                  data.loan.forEach(dat => {
                      if (dat.due === null) {
                          dat.due = "No due date"
                      } else {
                          var dueDate = new Date(dat.due);
                          dat.due = "Due on " + dueDate.toDateString();
                      }
                      vm.cards.push(dat)
                  });
              }).catch(function (err) {
                  alert(err);
              });
      },
      hideMakeOffer() {
          this.showMakeOffer = false
          console.log(this.showMakeOffer)
      }
  },
  mounted() {
      if(localStorage.getItem('disableTutorial') || localStorage.getItem('token')) {
          this.enableTutorial = false
      } else {
          this.enableTutorial = true;
      }
      bus.$on('hide', (hide) => {
          this.showMakeOffer = false
      });
  }
}
</script>

<style scoped>
    .hooper {
        position: fixed;
        top: 48px;
        height: calc(81vh - 48px);
    }
</style>
